import { api } from "@api/api";
import { Activity } from "@modules/activities/types";
import { ActivityFormValues } from "@modules/activities/validations";

export async function editActivityService(id: string, data: Partial<ActivityFormValues>): Promise<Activity> {
  const { image, ...body } = data;
  const payload = !image ? { ...body, image: null } : body;

  const { data: activity } = await api.patch<Activity>(`v1/activity_admin/${id}/`, payload);

  if (image && image instanceof File) {
    const formData = new FormData();
    formData.append("image", image);

    const { data: activity } = await api.patch<Activity>(`v1/activity_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return activity;
  }

  return activity;
}
